'use strict';

import type { CommissionStatementMappingCompany } from '../../Entities/CommissionStatement/CommissionStatementMappingCompany';
import { EntityCollection } from '../EntityCollection';

export class CommissionStatementMappingCompanyCollection extends EntityCollection<CommissionStatementMappingCompany> {}
